import { z } from "zod";

import { leadUpdateRequestSchema } from "@pbz/schema/lead";

// Application reference number schema - only leadId and arnNumber
export const applicationReferenceNumberSchema = leadUpdateRequestSchema
  .pick({
    leadId: true,
    arnNumber: true,
  })
  .extend({
    arnNumber: z.string().min(1, "Application reference number is required"),
  });

export type ApplicationReferenceNumberFormData = z.infer<
  typeof applicationReferenceNumberSchema
>;

// Schema for plan selection form
export const planSelectionSchema = z.object({
  bankId: z.number().positive("Please select a bank"),
  planId: z.number().positive("Please select a plan"),
});

export type PlanSelectionForm = z.infer<typeof planSelectionSchema>;
